import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import FeedIcon from '@mui/icons-material/Feed';
import Chip from '@mui/material/Chip';
import React from 'react';
import { useQuery } from '../hooks/useQuery';

const ItemPedido = ({ item, onClick, onClickDownload, index }) => {
  const [isDownloadingPdf, setIsDownloadingPdf] = React.useState(false);
  const { detalhePedido } = useQuery();

  async function downloadPdf(path, filename) {
    const anchor = document.createElement('a');
    anchor.href = path;
    anchor.setAttribute('target', '_blank');
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }

  const downloadPedido = async (contrato) => {
    try {
      setIsDownloadingPdf(true);
      const result = await detalhePedido(contrato);
      if (!result.data.data.pedido[0].pedido_pdf) {
        alert('PDF não encontrado');
        return;
      }
      downloadPdf(result.data.data.pedido[0].pedido_pdf, 'pedido.pdf');
    } catch (error) {
      console.log(error);
    } finally {
      setIsDownloadingPdf(false);
    }
  };

  const handleCutString = (str) => {
    if (!str) return '';
    return str.length > 30 ? `${str.substring(0, 26)}...` : str;
  };

  return (
    <tr>
      <td colSpan={6}>
        <Accordion
          style={{
            padding: 0,
            boxShadow: 'none',
            margin: 0,
          }}
        >
          <AccordionSummary
            style={{
              padding: 0,
              margin: 0,
              height: '5rem',
              borderBottom: '1px solid #e2e9ee',
              background: index % 2 === 1 ? 'white' : '#f0eded',
            }}
            expandIcon={<ExpandMoreIcon style={{ marginRight: '1rem' }} />}
            aria-controls={'panel-content' + item.contrato}
            id={'panel-header' + item.contrato}
          >
            <table
              style={{
                width: '100%',
              }}
            >
              <tbody>
                <tr style={{}}>
                  <td
                    style={{
                      color: '#0e72b8',
                      width: '15.2%',
                      padding: '1rem',
                    }}
                  >
                    {item.num_pedido}
                  </td>
                  <td
                    style={{ width: '17.98%', padding: '1rem', fontSize: '' }}
                  >
                    <p className="w-100 ellipsin">
                      {handleCutString(item.narrativa)}
                    </p>
                  </td>
                  <td
                    style={{ width: '20%', padding: '1rem', fontSize: '1rem' }}
                  >
                    {item.nom_consultor}
                  </td>
                  <td
                    style={{
                      width: '12.66%',
                      padding: '1rem',
                      fontSize: '1rem',
                    }}
                  >
                    {item.data_vigencia}
                  </td>
                  <td
                    style={{ width: '8%', padding: '1rem', fontSize: '1rem' }}
                  >
                    <Chip label="Pedido" color="warning" />
                  </td>
                  <td style={{ width: '24%', fontSize: '1rem' }}>
                    <Button
                      onClick={(e) => {
                        e.stopPropagation();
                        downloadPedido(item.num_pedido);
                      }}
                      variant="contained"
                      style={{ marginRight: 2 }}
                      disabled={isDownloadingPdf}
                    >
                      {isDownloadingPdf ? (
                        <CircularProgress size={24} />
                      ) : (
                        <SaveAltIcon sx={{ fontSize: 24 }} />
                      )}
                    </Button>
                    <Button
                      variant="contained"
                      style={{ marginRight: 4 }}
                      onClick={onClick}
                    >
                      <FeedIcon sx={{ fontSize: 24, marginRight: 1 }} />
                      Notas Fiscais
                    </Button>
                  </td>
                </tr>
              </tbody>
            </table>
          </AccordionSummary>
          <AccordionDetails>
            <p style={{ color: '#0e72b8' }}>Natureza</p>
            <p style={{ color: '#919191' }}>{item.natureza}</p>
            <p style={{ color: '#0e72b8' }}>Vigência</p>
            <p style={{ color: '#919191' }}>{item.data_vigencia}</p>
            <p style={{ color: '#0e72b8' }}>Narrativa</p>
            <p style={{ color: '#919191' }}>{item.narrativa}</p>
          </AccordionDetails>
        </Accordion>
      </td>
    </tr>
  );
};

export default ItemPedido;
